import { raise } from "./raise.js";

export function ok(value: unknown, message?: string | Error): asserts value {
	// eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
	if (!value) {
		raise(message ?? `Value is not OK: ${String(value)}`);
	}
}
